let baseUrl = ''
let websocketUrl = ''
if (process.env.NODE_ENV === 'production') {
    baseUrl = 'https://api2.vszdw.de/api/pm/';
    websocketUrl = 'api2.vszdw.de'
}
else {
    baseUrl = 'https://publicservicemanagerapi2.test/api/pm/'
    websocketUrl = 'api2.vszdw.de'
}

export const apiHost = baseUrl;
export const websocketHost = websocketUrl;